import React, { useState, useEffect, useCallback } from 'react';
import { Card, Container, Row, Button, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Image } from "react-bootstrap";
import abcLogo from '../../../assets/images/books.jpeg';
import book from '../../../assets/images/books.jpeg';
import softCopy from '../../../assets/images/softCopy.jpg';
import blog from '../../../assets/images/blog.jpg';
import vlog from '../../../assets/images/vlog.png';
import quiz from '../../../assets/images/did-you-know.jpeg';
import resource from '../../../assets/images/resources.jpeg';
import cardCss from './Card.css';
import Modal from '../Modal/Modal';
import Aux from '../../../hoc/Aux/Aux';
import { useHistory } from 'react-router-dom';


const alicard = (props) => {
const [softClicked, setSoftClicked] = useState(false);
const [hardClicked, setHardClicked] = useState(false);
const [blogClicked, setBlogClicked] = useState(false);
const [vlogClicked, setVlogClicked] = useState(false);
const [quizClicked, setQuizClicked] = useState(false);
const [resourceClicked, setResourceClicked] = useState(false);
const [clicked, setClicked] = useState(false);


const purchaseCancelHandler = () => {
  setClicked(false);
};

const handleBlogClicked = () => {
    setBlogClicked(true);
    setVlogClicked(false);
    setSoftClicked(false);
    setHardClicked(false);
    setQuizClicked(false);
    setResourceClicked(false);
    setClicked(true);
};

const handleVlogClicked = () => {
  setBlogClicked(false);
  setVlogClicked(true);
  setSoftClicked(false);
  setHardClicked(false);
  setQuizClicked(false);
  setResourceClicked(false);
  setClicked(true);
};

const handleSoftClicked = () => {
  setBlogClicked(false);
  setVlogClicked(false);
  setSoftClicked(true);
  setHardClicked(false);
  setQuizClicked(false);
  setResourceClicked(false);
  setClicked(true);
};

const handleHardClicked = () => {
  setBlogClicked(false);
  setVlogClicked(false);
  setSoftClicked(false);
  setHardClicked(true);
  setQuizClicked(false);
  setResourceClicked(false);
  setClicked(true);
};

const handleQuizClicked = () => {
  setBlogClicked(false);
  setVlogClicked(false);
  setSoftClicked(false);
  setHardClicked(false);
  setQuizClicked(true);
  setResourceClicked(false);
  setClicked(true);
};

const handleResourceClicked = () => {
  setBlogClicked(false);
  setVlogClicked(false);
  setSoftClicked(false);
  setHardClicked(false);
  setQuizClicked(false);
  setResourceClicked(true);
  setClicked(true);
};

let orderSummary = null;

if (softClicked) {
  orderSummary = (
    <div style={{textAlign:'left'}}>
        Collection of PDFs books on various topics. You can search a book by its title, tag or author by going to the above link. 
        <br></br><br></br>
        Only registered users can upload a PDF and tag it.
    </div>
  );
}

if (blogClicked) {
  orderSummary = (
    <div style={{textAlign:'left'}}>
    Registered user can write a blog about a soft copy or a hard copy book available at the Ali Book Club by going to Library soft/hard copy section and clicking Blog button under a book.
    <br></br><br></br>
    Blog is expected to summarize the book, main topics covered and likes/dislikes about the book. 
    <br></br><br></br> 
    This section list Blogs on all books. Blogs specific about a book can be seen by going to Library soft/hard copy section and clicking Blog button under a book.
    </div>
);

}


if (hardClicked) {
  orderSummary = (
    <div style={{textAlign:'left'}}>
    Registered user can send a request for a book from another group member he/she belongs to by going to the above link. <br></br><br></br>
    User is expected to return a book after specified time or pay the cost of book to the owner if a book is lost.<br></br> <br></br>
    User will get a daily email alert once a due date has passed, reminding to return the book to the owner.
    </div>
);

}


if (vlogClicked) {
  orderSummary = (
    <div style={{textAlign:'left'}}>
    Registered user can add a link to a youtube video blog about a soft copy or a hard copy book available at the Ali Book Club. User can also request website admin (alibookclub.org@gmail.com) to upload a video on his/her behalf on the Ali Book Club youtube channel. VLOGs associated with a book are are available under a book section. 
    <br></br><br></br>
    Video blog is expected summarize the book, main topics covered and likes/dislikes about a book. 
    <br></br><br></br> 
    Vlogger is star rated based on number of reactions received.
    </div>
);

}


if (quizClicked) {
  orderSummary = (
    <div style={{textAlign:'left'}}>
    A list of question and answers on various topics. This question list can come in handy for conducting quizzes. Each question is provided with a brief answer and book references. Questions can be tagged and are searchable on these tags.  
    </div>
);

}


if (resourceClicked) {
  orderSummary = (
    <div style={{textAlign:'left'}}>
        List of websites where you can find books/pdfs on various topics
    </div>
);

}




const history = useHistory();

const routeChange=(path)=> {
  //let path = `/PdfTable`;
  history.push(path);
  }

return (
  <Aux>
  <Modal show={clicked} modalClosed={purchaseCancelHandler}>
      {orderSummary}
  </Modal>
  <Container style={{padding:'0px 0px 0px 0px'}}>
<Row className={cardCss.aliRow}>
  <Col sm={6}>
  <Card className={cardCss.aliCard} >
    <Card.Img variant="top" as={Image} src={softCopy}    className={cardCss.aliImg} onClick={(event) => {routeChange("/pdfTable")}}/>
    <Card.Body>
      <Card.Title style={{backgroundColor:"#042a4a", fontSize:"20px", color:"white"}}>
        
        
        <Button color="primary" className="px-4" style={{width:"100%", backgroundColor:"#042a4a", padding:"10px 5px 10px 5px", fontSize:"20px", color:"white", border: "none"}}
                onClick={(event) => {routeChange("/pdfTable")}}
                  >
                  Library - Soft Copy
      </Button>

        </Card.Title>
      <Card.Text style={{textAlign:'left'}}>
        Collection of PDFs books on various topics. You can search a book by its title, tag or author by going to the above link. 
        <button class="btn btn-link btn-lg" onClick={() => handleSoftClicked(true) }>More Info</button>
      </Card.Text>
    </Card.Body>
  </Card>
  <br></br><br></br>
  </Col>

  <Col sm={6}>
  <Card className={cardCss.aliCard}>
  <Card.Img variant="top" as={Image} src={blog}  className={cardCss.aliImg} onClick={(event) => {routeChange("/BlogList")}}/>
    <Card.Body>
    <Card.Title style={{backgroundColor:"#042a4a", fontSize:"20px", color:"white"}}>
      
    <Button color="primary" className="px-4" style={{width:"100%", backgroundColor:"#042a4a", padding:"10px 5px 10px 5px", fontSize:"20px", color:"white", border: "none"}}
                onClick={(event) => {routeChange("/BlogList")}}
                >
                  BLOG
      </Button>
      
    </Card.Title>
      <Card.Text style={{textAlign:'left'}}>
        <div style={{textAlign:'left',  overflow : 'auto', height:'100px'}}>
        This section list Blogs on all books. Registered user can write a blog by clicking Blog button under a book in the library section. 
        <button class="btn btn-link btn-lg" onClick={() => handleBlogClicked()}>More Info</button>
        </div>
      </Card.Text>
    </Card.Body>
  </Card>
</Col>

  </Row>


  <Row className={cardCss.aliRow}>

 <Col sm={6}>
 <Card className={cardCss.aliCard}>
 <Card.Img variant="top" as={Image} src={vlog}   className={cardCss.aliImg} onClick={(event) => {routeChange("/VlogList")}} />
    <Card.Body>
    <Card.Title style={{backgroundColor:"#042a4a", fontSize:"20px", color:"white"}}>
      
    <Button color="primary" className="px-4" style={{width:"100%", backgroundColor:"#042a4a", padding:"10px 5px 10px 5px", fontSize:"20px", color:"white", border: "none"}}
                onClick={(event) => {routeChange("/VlogList")}}
                >
                  VLOG
      </Button>
      
    </Card.Title>
    <Card.Text style={{textAlign:'left'}}>
      <div style={{textAlign:'left',  overflow : 'auto', height:'100px'}}>
        User can add a link to a youtube video blog about a soft copy or a hard copy book available at the Ali Book Club. 
        <button class="btn btn-link btn-lg" onClick={() => handleVlogClicked(true)}>More Info</button>
        </div>
      </Card.Text>
    </Card.Body>
  </Card>
  <br></br><br></br>
  </Col>



  <Col sm={6}>
  <Card className={cardCss.aliCard}>
  <Card.Img variant="top" as={Image} src={book}    className={cardCss.aliImg} onClick={(event) => {routeChange("/HardLibrary")}} />
    <Card.Body>
    <Card.Title style={{backgroundColor:"#042a4a", fontSize:"20px", color:"white"}}>
      
    <Button color="primary" className="px-4" style={{width:"100%", backgroundColor:"#042a4a", padding:"10px 5px 10px 5px", fontSize:"20px", color:"white", border: "none"}}
                onClick={(event) => {routeChange("/HardLibrary")}}
                >
                  Library - Hard Copy
      </Button>
      
    </Card.Title>
      <Card.Text style={{textAlign:'left'}}>
      <div style={{textAlign:'left',  overflow : 'auto', height:'100px'}}>
        Registered user can send a request for a book from another group member he/she belongs to by going to the above link.
        <button class="btn btn-link btn-lg" onClick={() => handleHardClicked(true)}>More Info</button>
        </div>
      </Card.Text>
    </Card.Body>
  </Card>
 </Col>



  </Row>











  <Row className={cardCss.aliRow}>

 <Col sm={6}>
 <Card className={cardCss.aliCard}>
 <Card.Img variant="top" as={Image} src={quiz}   className={cardCss.aliImg} onClick={(event) => {routeChange("/QuizList")}} />
    <Card.Body>
    <Card.Title style={{backgroundColor:"#042a4a", fontSize:"20px", color:"white"}}>
      
    <Button color="primary" className="px-4" style={{width:"100%", backgroundColor:"#042a4a", padding:"10px 5px 10px 5px", fontSize:"20px", color:"white", border: "none"}}
                onClick={(event) => {routeChange("/QuizList")}}
                >
                  QUIZ QUESTIONS
      </Button>
      
    </Card.Title>
    <Card.Text style={{textAlign:'left'}}>
      <div style={{textAlign:'left',  overflow : 'auto', height:'100px'}}>
        A List of question and answers on various topics. This question list can come in handy for conducting quizes.   
        <button class="btn btn-link btn-lg" onClick={() => handleQuizClicked(true)}>More Info</button>
        </div>
      </Card.Text>
    </Card.Body>
  </Card>
  <br></br><br></br>
  </Col>



  <Col sm={6}>
  <Card className={cardCss.aliCard}>
  <Card.Img variant="top" as={Image} src={resource}    className={cardCss.aliImg} onClick={(event) => {routeChange("/HardLibrary")}} />
    <Card.Body>
    <Card.Title style={{backgroundColor:"#042a4a", fontSize:"20px", color:"white"}}>
      
    <Button color="primary" className="px-4" style={{width:"100%", backgroundColor:"#042a4a", padding:"10px 5px 10px 5px", fontSize:"20px", color:"white", border: "none"}}
                onClick={(event) => {routeChange("/ResourceList")}}
                >
                  Book Resources
      </Button>
      
    </Card.Title>
      <Card.Text style={{textAlign:'left'}}>
      <div style={{textAlign:'left',  overflow : 'auto', height:'100px'}}>
        List of book websites where you can find books/pdfs on various topics
        <button class="btn btn-link btn-lg" onClick={() => handleResourceClicked(true)}>More Info</button>
        </div>
      </Card.Text>
    </Card.Body>
  </Card>
 </Col>



  </Row>









</Container>
</Aux>

);

};

export default alicard;


// WEBPACK FOOTER //
// ./src/components/UI/Card/Card.js